module.exports = __webpack_public_path__ + "img/download_banner.2bb56037.png";